<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons.jade
	include ../../node_modules/tangram-ui/src/elements/tge-button/tge-button.jade
	.asw-map(:class="{ 'poll-visible': pollData }")
		.asw-map_container
			Search(:electorates="features.electorates", @searchResultClick="searchClick")
			.asw-map_find
				a.asw-map_find_link(href='https://electorate.aec.gov.au/', target='_blank')
					span|{{ "Don't know your electorate?" }}
					+tge-svg-icons({ icon: 'offnet-link' })
			.asw-map_tools
				//-.asw-map_tool.fullscreen(@click="toggleFullscreen", :class="{ active: fullscreen }")
					include ../assets/noun_45678_cc.svg
				.asw-map_tool.reset(@click="resetZoom")
					+tge-svg-icons({ icon: 'refresh' })
			template
				.map-item
					svg.map-item_svg(:width="displayWidth", :height="displayHeight", @click.self="resetZoom($event)", :class="{  filtered: this.filters.party, responsive: responsive }")
							rect.background(:width="displayWidth", :height="displayHeight", @click="resetZoom($event)")
							g.features(v-if="topojson")
								
								g#boundaries()
									template(v-for="(feature, i) in features.boundaries")
										path.boundary(
											:district-id="feature.properties.id",
											:district-name="feature.properties.Elect_div",
											:d="feature.path",
											:style="{ fill: feature.fill/*, opacity: boundaryStyles.opacity, display: boundaryStyles.display*/ }",
											@click="onClicked(feature, $event)"
										)

								g#electorates
									path.electorate(
										v-for="(feature, i) in features.electorates",
										:electorate-name="feature.properties.Elect_div",
										:electorate-locations="feature.properties.electorate_locations",
										:electorate-state="feature.properties.electorate_state",
										:electorate-id="feature.properties.fid",
										:d="feature.path",
										:style="{ fill: feature.fill }",
										:active="feature.properties.Elect_div === selectedID",
										@click="countyclicked(feature, $event)",
										@mouseover="hexHovered(feature, $event)",
										@mouseleave="hexHoverOut"
									)

								g#capitals()
									template(v-for="(feature, i) in features.capitals")
										path.capital(
											:district-id="feature.properties.id",
											:district-name="feature.properties.Elect_div",
											:d="feature.path",
											:style="{ fill: feature.fill/*, opacity: capitalStyles.opacity, display: capitalStyles.display*/ }",
											@click="onClicked(feature, $event)"
										)

			Poll(v-if="pollData",
				:pollData="pollData",
				:emojiData="emojiData",
				:environ="environ",
				:resultDate="resultDate",
				@close="pollClose"
			)

			AusChart(v-if="results && auschart",
				:emojiData="emojiData",
				:results="results"
			)

			HexHover(v-if="hexHoverData",
				:hexHoverData="hexHoverData",
				:style="{ left: tooltipStyles.left, top: tooltipStyles.top }",
			)


</template>
<script>

	import topojsonFeature from 'topojson-client/src/feature';
	import topojsonMesh from 'topojson-client/src/mesh';

	import { interpolate } from 'd3-interpolate';
	import { geoMercator, geoPath, geoCentroid } from 'd3-geo';
	import { select, event } from 'd3-selection';
	import { zoom, zoomIdentity } from 'd3-zoom';
	import quantize from 'd3-scale/src/quantize';
	import threshold from 'd3-scale/src/threshold';
	import linear from 'd3-scale/src/linear';

	import Poll from './Poll.vue';
	import AusChart from './AusChart.vue';
	import HexHover from './HexHover.vue';
	import Search from './Search.vue';

	const d3 = {
		geoMercator,
		geoPath,
		interpolate,
		select,
		scale: {
			linear,
			quantize,
			threshold
		},
		zoom,
		zoomIdentity
	};

	export default {
		name: "map-item-svg",
		components: { Poll, AusChart, HexHover, Search },
		props: {
			fullscreen: {
				type: Boolean,
				default: false
			},
			geodata: {
				type: Object,
				required: true
			},
			results: { },
			width: {
				type: Number,
				//default: 665
				// default:865
				default:628
			},
			height: {
				type: Number,
				//default: 650
				//default: 730
				default: 538
			},
			initialScale: {
				type: Number,
				//default: 900
			},
			centerPoint: {
				type: Array,
				default: () => [133.29024086902227,-27.772410375241137]
			},
			zoomScale: {
				type: Array,
				default: () => [1, Infinity]
			},
			filters: {
				type: Object,
				default: () => ({})
			},
			responsive: {
				type: Boolean,
				default: true
			},
			emojiData: {
				type: Object,
				required: true
			},
			environ: {
				type: String
			},
			resultDate: {
				type: Number
			}
		},

		data() {
			return {
				event,
				hoverEvent: null,
				selectedID: null,
				centered: null,
				activePath: null,
				displayWidth: this.width, //0,
				displayHeight: this.height, //0
				pollData: null,
				hexHoverData: null,
				auschart:true
			}
		},
		mounted: function(){
			// console.log('map-item mounted', this.$el);
			this.resize();
			this.initZoom();
			window.addEventListener('resize', this.resize);
			window.addEventListener('orientationchange', this.resize);
		},
		computed: {
			/*translateXOffset() {
				return this.PollData ? 150 : 0;
			},*/
			scale() {
				return this.displayWidth * 1.35;
			},
			projection() {
				const projection = d3.geoMercator();
				/*
				console.log(this.initialScale)
				projection.scale(this.scale);
				return projection;

				if (this.initialScale) {
					projection.scale(this.initialScale);
				} else {*/
				// console.log('fitzsize')
				projection.fitSize([this.dimensions.width * 1.15, this.dimensions.height], this.topojson.electorates)
					.center(this.centerPoint)
					.translate([this.dimensions.width / 2, this.dimensions.height / 2]);
				//}

				return projection;
			},
			path() { return d3.geoPath().projection(this.projection); },
			svg() { return d3.select(this.$el).select('svg.map-item_svg'); },
			featuresGroup() { return this.svg.select("g.features"); },
			topojson() {
				//const stateBoundaries = this.geodata.objects['STE_2011_AUST'];
				const hexElectorates = this.geodata.objects['sentiment-labelled-hex-electorates'];
				const boundaries = this.geodata.objects['sentiment-background-electorates'];
				const capitals = this.geodata.objects['sentiment-city-cbd-electorate-points'];
				
				return {
					electorates: topojsonFeature(this.geodata, hexElectorates),
					boundaries: topojsonFeature(this.geodata, boundaries),
					capitals: topojsonFeature(this.geodata, capitals),
					borders: topojsonMesh(this.geodata, hexElectorates, function(a, b) { return a !== b; })
				};
			},
			features() {
				const
					createPathsHex = ({ properties, ...feature }) => ({
						...feature,
						path: this.path(feature),
						fill: this.getHexFillColor(this.results.electorates[properties.fid]),
						properties: {
							...properties,
							//region_name: properties.Elect_div,
							result: this.results[properties.Elect_div],
						},
						label: properties['id'] ? {
							coords: this.projection(geoCentroid(feature))
						} : null
					});

				const
					createPaths = ({ properties, ...feature }) => ({
						...feature,
						path: this.path(feature),
						// fill: this.getFillColour(this.results[properties.Elect_div]),
						properties: {
							...properties,
							// region_name: properties.NAME
							//result: this.results[properties.Elect_div],
						},
						// label: properties['STE_CODE11'] ? {
						/*
						label: properties['id'] ? {
							coords: this.projection(geoCentroid(feature))
						} : null
						*/
					});

				const features = {
					electorates: this.topojson.electorates.features.map(createPathsHex),
					boundaries: this.topojson.boundaries.features.map(createPaths),
					capitals: this.topojson.capitals.features.map(createPaths),
					borders: {
						path: this.path(this.topojson.borders)
					}
				};

				return features;
			},
			aspectRatio() { return this.height / this.width; },
			dimensions: {
				get: function () {
					return {
						width: this.displayWidth,
						height: this.displayHeight
					};
				},
				// setter
				set: function ({ width, height }) {
					if (height === 0) {
						//console.log('height calculated at zero. Keeping: ' + this.displayHeight);
					} else {
						if (this.fullscreen) {
							this.displayHeight = height;
						} else {
							this.displayHeight = width * this.aspectRatio;
						}
					}

					if (width === 0) {
						//console.log('width calculated at zero. Keeping: ' + this.displayWidth);
					} else {
						this.displayWidth = width;
					}
				}
			},
			zoom() {
				const zoom = d3.zoom()
					.scaleExtent(this.zoomScale)
					//.translateExtent([[-0, -0], [this.dimensions.width + this.translateXOffset, this.dimensions.height + 0]])
					.translateExtent([[-0, -0], [this.dimensions.width, this.dimensions.height + 0]])
					.on("zoom", this.onZoom);

				return zoom;
			},
			/*
			capitalStyles() {
				let
					max = 0.9,
					k = this.event && this.event.transform ? max - (this.event.transform.k - max) : max;
					console.log('k',k);
				if (k < 0.35) k = 0;
				return {
					opacity: k,
					'fill-opacity': k,
					display: k === 0 ? 'none' : 'block'
				}
			},
			boundaryStyles() {
				let
					max = 0.9,
					k = this.event && this.event.transform ? max - (this.event.transform.k - max) : max;
					console.log('k',k);
				if (k < 0.35) k = 0;
				return {
					opacity: k,
					'fill-opacity': k,
					display: k === 0 ? 'none' : 'block'
				}
			},
			*/
			tooltipStyles() {
				
				// make sure hovers don't go outside of map
				const topValue = ( this.displayHeight/2 > this.hoverEvent.clientY ) ? this.hoverEvent.clientY + 10 : this.hoverEvent.clientY - 110;
				const leftValue = ( this.displayWidth/2 > this.hoverEvent.clientX ) ? this.hoverEvent.clientX + 10 : this.hoverEvent.clientX - 210;
				
				return {
					top: topValue + 'px',
					left: leftValue + 'px'
				}
			}
		},
		methods: {
			pollClose() {
				this.pollData = null;
				this.selectedID = null;
				this.$emit('closeElecPoll');
			},
			hexHoverOut() {
				this.hexHoverData = null;
				this.hoverEvent = null;
			},
			getHexFillColor(sentiment) {
				return sentiment ? this.emojiData[sentiment].color : '#ccc';
			},
			resize() {
				// return;
				this.dimensions = {
					width: this.$el.clientWidth,
					height: this.$el.clientHeight
				};

				this.initZoom();
			},
			onClicked(d, e) {
				// console.log('click',d, e, this);
				if (this.activePath === e.target) {
					this.resetZoom();
				} else {
					this.zoomToDistrict(d, e);
				}
			},/*,
			updateBoundaries() {
				// this.$store.commit('loading', true);
				setTimeout(() => {
					// this.$store.commit('loading', true);
					this.topojson = topojsonFeature(this.geodata, this.boundaries);

					// setTimeout(() => this.$store.commit('loading', false), 300);
				}, 300)
				this.resize();
			},*/
			searchClick(electorate) {
				const
					name =  electorate.properties.Elect_div,
					el = this.$el.querySelector(`path[electorate-name="${name}"]`)

				this.zoomToDistrict(electorate, { target: el })
				el.dispatchEvent(new Event("click"))
			},

			initZoom() { this.svg.call(this.zoom); },
			onZoom() {
				this.event = d3.event = event;
				this.featuresGroup.attr("transform", d3.event.transform).selectAll("path:not(.active)").style("stroke-width", 1 / d3.event.transform.k + "px" );
				this.featuresGroup.attr("transform", d3.event.transform).select("path.active").style("stroke-width", 2 / d3.event.transform.k + "px" );
				// if (k > 3 ) {}
			},
			zoomToDistrict(d, e) {
				//console.log(d, e)
				this.auschart = false;

				if (this.activePath) this.activePath.removeAttribute('active', 'active');
				this.activePath = e.target;
				this.activePath.setAttribute('active', 'active')

				const
					bounds = this.path.bounds(d),
					dx = bounds[1][0] - bounds[0][0],
					dy = bounds[1][1] - bounds[0][1],
					x = (bounds[0][0] + bounds[1][0]) / 2,
					y = (bounds[0][1] + bounds[1][1]) / 2,
					scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.dimensions.width, dy / this.dimensions.height))),
					translate = [this.dimensions.width / 2 - scale * x, this.dimensions.height / 2 - scale * y];

				this.svg.transition()
					.duration(500)
					.call( this.zoom.transform, d3.zoomIdentity.translate(translate[0],translate[1]).scale(scale) ); // updated for d3 v4

			},
			resetZoom() {
				//console.log('reset');
				if (this.activePath) {
					this.activePath.removeAttribute('active', 'active');
					this.activePath = null;
				}

				this.selectedID = null;
				this.pollData = null;

				this.svg.transition()
					.duration(300)
					.call( this.zoom.transform, d3.zoomIdentity );
				this.initZoom();

				this.auschart = true
			},
			countyclicked(d) {
				//console.log(d);
				this.pollData = d;
				this.selectedID = d.properties.Elect_div;
				this.initZoom();
			},
			hexHovered(d, e) {
				this.hoverEvent = e;
				this.hexHoverData = d;
			},
			toggleFullscreen() {
				this.$emit('fullscreen', !this.fullscreen);
				this.resetZoom();
				setTimeout(this.resize, 10)
			}

		}
	}
</script>
<style lang="scss">
	@import "node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons";
	.asw-map {
		flex: 1 1 100%;
		//margin: $m-spacing;
		margin: 6px 6px 6px;

		.asw-fullscreen & {
			overflow: hidden;
		}

		body.newscomau .ssm-results:not(.asw-fullscreen) & {
			margin: $m-spacing 0;
		}

		/*
		@include MQ_MobileTablet() {

			.ssm-fullscreen & {
				height: 100vw;
			}

		}*/

		&_container {
			// position: relative;
			// height: 100%;
			background: #fff;
		}

		.map-item {
			overflow:hidden;
		}

		.map-item_svg {
			width: 100%;
			cursor: grab;
			overflow:hidden;
			position:relative;
			z-index: 15;
			margin-bottom:30px; //70px

			//svg has diff dimensions to g container, why???
			&:not(:root) {
				overflow: visible;
			}
			
			path {
				&:not([active]):hover {
					transition: opacity 0.3s;
					opacity: 0.8 !important;
				}
			}

			&.hasSelection {
				path:not(.active) { opacity: 0.2; }
			}

		}

		.background { fill: none; pointer-events: all; }

		#boundaries {
			path {
				fill:#fff!important;
				stroke:#ccc!important;
				cursor: zoom-in;
			}
			//[active] { display:none; }
		}

		#capitals {
			path {
				fill:#000!important;
				stroke:#000!important;
			}
		}

		.electorate {
			fill: #aaa;
			stroke: #fff;
			stroke-width: .5px;
			cursor: pointer;
			transition: fill 0.3s ease;
			&[active] {
				fill: #000 !important;
			}
		}

		text.label {
			font-weight: bold;
		    text-anchor: middle;
		    cursor: default;
		    fill: white;
		    font-size: 30px;
		    fill-opacity: 0.4;
			pointer-events:none;

			&[district-id="6"],
			&[district-id="8"] {
				font-size: 20px;
			}

			.pc {
				font-size: 0.5em;
			}
		}
	}

	.asw-map {
		/**
		TOOLS
		**/

		&_tools {
		    position: absolute;
		    right: 0;
		    top: 30px; //0
		    padding: 6px 12px 12px;
		    background: rgba(255,255,255,1);
			transition: right 0.3s;
			z-index:30;
		}
		@include MQ_SmallMedium() {
			&.breakdown-visible &_tools {
				right: 329px;
			}
		}
		@include MQ_LargeOnly() {
			.ssm-fullscreen &.breakdown-visible &_tools {
				right: 329px;
			}
		}


		&_tool {
			padding: 6px;
			border: 1px solid currentColor;
			margin-top: 6px;
			cursor: pointer;
			height: 38px;
			width: 38px;

			path {
				fill: currentColor
			}

			&.active,
			&:hover {
				color: #19acf0;
			}
			text {display: none;}
		}

		&_find {
			//position: absolute;
			//top:90px;
			//left:6px;
			z-index: 19;
			&_link{
				font-size:0.7em;
				color:#d3d3d3;
				line-height: 1em;
			}
			.tge-svg-icon {
				display:inline-block;
				width:15px;
				height:15px;
				position:relative;
				top:4px;
				margin-left:4px;
			}
		}

	}


</style>



// WEBPACK FOOTER //
// src/components/MapSVG.vue